import { render, staticRenderFns } from "./ViewSub.vue?vue&type=template&id=424e647c"
import script from "./ViewSub.vue?vue&type=script&lang=ts"
export * from "./ViewSub.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports